import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-551351c6")

_pushScopeId("data-v-551351c6")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Customer Service Rating")
const _hoisted_2 = { class: "d-content pb-32 px-16" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Help us to improve the customer service. Thx for your support. Rating of 5 is the highest. ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_t = _resolveComponent("t")
  const _component_TheScoreItem = _resolveComponent("TheScoreItem")
  const _component_DialogTemplate = _resolveComponent("DialogTemplate")

  return (_openBlock(), _createBlock(_component_DialogTemplate, null, {
    title: _withId(() => [
      _createVNode(_component_t, { path: "home_45" }, {
        default: _withId(() => [
          _hoisted_1
        ]),
        _: 1
      })
    ]),
    controls: _withId(() => [
      _createVNode("button", {
        class: ["flex-1 btn", {'primary': _ctx.submitAble}],
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
      }, [
        _createVNode(_component_t, {
          path: "home_50",
          custom: ""
        }, {
          default: _withId(({td}) => [
            _createTextVNode(_toDisplayString(td || 'Submit'), 1)
          ]),
          _: 1
        })
      ], 2)
    ]),
    default: _withId(() => [
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_t, {
          as: "p",
          path: "home_46",
          class: "c-title mb-16 mt-24"
        }, {
          default: _withId(() => [
            _hoisted_3
          ]),
          _: 1
        }),
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
          return (_openBlock(), _createBlock("div", {
            key: index,
            class: "mb-16"
          }, [
            _createVNode(_component_t, {
              path: item.label
            }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(item.title), 1)
              ]),
              _: 2
            }, 1032, ["path"]),
            _createVNode(_component_TheScoreItem, {
              onChange: ($event: any) => (_ctx.handleScoreChange(index, $event))
            }, null, 8, ["onChange"])
          ]))
        }), 128))
      ])
    ]),
    _: 1
  }))
})